<template>
  <Modal :id="'cmp-booking-plugins-plugin-adapter'" @cancelled="onCancel">
    <template slot="header">Plugin Runner</template>

    <template slot="body">
      <iframe ref="plugin_iframe" :src="iframeURL" frameborder="0"></iframe>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { MHTTPCL,HttpClient } from "../../services/http/http-client";
import { type } from "ramda";
import { JSONX } from "../../utility";

export default {
  components: {
    Modal,
  },
  props: ["pluginData","account"],
  data: function () {
    return {};
  },
  mounted: async function () {
    const iframe = this.$refs["plugin_iframe"];
     var accountModel=this.account;
    iframe.onload = async (e) => {
      window.addEventListener("message", this.onWindowMessage);
    //   browser.browserSettings.allowPopupsForUserEvents.set({
    //   value: false,
    // });
     // await this.fetch();
      if (!this.pluginData.code) {
        return;
      }
      const postData = {
        message: "init_plugin",
        code: `
        (function() {
          var showAlertMessage = window.alert;
          var win = {};
          window.alert = function(message) {
              if (message !== 'Please allow popups for this website') {
                  showAlertMessage(message);
              }
          };
        }) ();
        ${this.pluginData?.code}`,
        baseURL: MHTTPCL.getBaseUrl(),

        ext_api_path: `${this.account.ext_api_path}`,
        client: `${MHTTPCL.clientName}`,
      };

      iframe.contentWindow.postMessage(JSON.stringify(postData), "*");
    };
  },
  destroyed: function () {
    console.log("Log: destroyed");
    window.removeEventListener("message", this.onWindowMessage);
  },
  computed: {
    hostname() {
      return window.location.hostname;
    },
    iframeURL() {
      const host =
        this.hostname == "localhost" ? "dev.berlin3.com" : this.hostname;

      return `https://${host}/v2_plugin_adapter/index.html`;
      // return `http://localhost:8080/v2_plugin_adapter/`;
    },
    plugin_id: function () {
      return this.$route.query["plugin_id"];
    },
  },
  methods: {
    async fetch() {
      const pluginData = await MHTTPCL.post("/plugins.pl", {
        section: "plugins",
        action: "plugin_code",
        plugin_id: this.plugin_id,
      });
      this.pluginData = pluginData.data;
    },
    onCancel() {
      this.$emit("cancelled");
    },
    onWindowMessage(event) {
      const postData = JSONX.tryParse(event.data);
      console.log("Log: onWindowMessage -> event.data", event.data, postData);
      if (postData.success) {
        if (postData.result.message == "close") {
          console.log("onCancel");
          this.onCancel();
        }
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-booking-plugins-plugin-adapter {
  iframe {
    width: 840px;
    height: 550px;
  }
}
</style>
